import { Route } from 'vue-router';
import { store } from '@/store';
import { getModule } from 'vuex-module-decorators';
import LoanStore from '@/loan/store';

const loanStore = getModule(LoanStore, store);

export const loanDetailsResolver = async (to: Route): Promise<void> => {
	const { loanId } = to.params;

	await loanStore.getAndSetLoanDetails(loanId);
};
